module.exports = __webpack_public_path__ + "img/kefu_2.f84a6afd.png";